const confirmationCodeES = {
	title: "Confirmar Cuenta",
	subtitle: "Ingresa el código enviado a tu correo",
	email: "Correo electrónico",
	code: "Código de Confirmación",
	button: "Confirmar",
	loading: "Confirmando...",
	resendCode: "Reenviar Código",
	sendingCode: "Enviando...",
	backToLogin: "Volver a Iniciar Sesión",
};
export default confirmationCodeES;
